import { apiClient } from './client';
import type { Country } from '../types';

interface CountriesResponse {
  message: string;
  data: Country[];
  total: number;
  page: number;
  totalPages: number;
}

export const countriesService = {
  async getAllCountries(): Promise<Country[]> {
    const response = await apiClient.get<CountriesResponse>('/countries', {
      params: {
        page: 1,
        limit: 350,
      },
    });
    return response.data?.data ?? [];
  },

  async getActiveCountries(): Promise<Country[]> {
    const response = await apiClient.get<{ message: string; data: Country[] }>('/countries/active');
    return response.data?.data ?? [];
  },

  async getShippingEnabledCountries(): Promise<Country[]> {
    const response = await apiClient.get<{ message: string; data: Country[] }>('/countries/shipping-enabled');
    return response.data?.data ?? [];
  },

  async getCountryByIsoCode2(isoCode2: string): Promise<Country | null> {
    const response = await apiClient.get<{ message: string; data: Country }>(`/countries/iso2/${isoCode2}`);
    return response.data?.data ?? null;
  },
};
